export default __webpack_public_path__ + "static/media/9.0cb287d5.jpeg";